import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const dashboardAPI = createApi({
  reducerPath: "DashBoard",
  baseQuery: customFetchBase,
  endpoints: (builder) => ({
    getInprogressTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetInprogressTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getAllOverdueTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetAllOverdueTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getDashboardTotalCount: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetDashboardTotalCount?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeKpiCounts: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeKpiCounts?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeOverdueTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeOverdueTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeDueTodayTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeDueTodayTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeInProgressTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeInProgressTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeCompletedTaskList: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeCompletedTaskList?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),

    getHomeMyProjects: builder.query({
      query: (userId) => ({
        url: `DashBoard/GetHomeMyProjects?UserId=${Number(userId)}`,
        method: "GET",
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
  }),
});

export const {
  useLazyGetInprogressTaskListQuery,
  useLazyGetAllOverdueTaskListQuery,
  useLazyGetDashboardTotalCountQuery,
  useLazyGetHomeKpiCountsQuery,
  useLazyGetHomeOverdueTaskListQuery,
  useLazyGetHomeDueTodayTaskListQuery,
  useLazyGetHomeInProgressTaskListQuery,
  useLazyGetHomeCompletedTaskListQuery,
  useLazyGetHomeMyProjectsQuery,
} = dashboardAPI;

export default dashboardAPI;
